import React from 'react'
import PropTypes from 'prop-types'

import styles from './Container.module.css'

const Container = ({ children, flex }) => (
  <div className={`${styles.container} ${flex ? styles.flex : ''}`}>{children}</div>
)

Container.propTypes = {
  children: PropTypes.node.isRequired,
  flex: PropTypes.bool,
}

export default Container
